<h1>Nuevo Usuario</h1>
<div class="mat-elevation-z4 divmarco">
<form [formGroup]="registerForm" (ngSubmit)="onSubmit()" autocomplete="off">
  <h1>Datos del Representante</h1>
  <hr>
  <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
    class="divconten">
    <div>
      <mat-form-field fxLayout="column" hintLabel="Ingrese su usuario" appearance="outline" class="input-width-275"
        floatLabel="always">
        <mat-label>Usuario:</mat-label>
        <input matInput formControlName="usuario" name="usuario" minlength="3" maxlength="100" autocomplete="off" required>
        <mat-icon matSuffix>person</mat-icon>
        <mat-error *ngIf="registerForm.controls['usuario'].hasError('required')">Usuario es requerido.</mat-error>
        <mat-error *ngIf="registerForm.controls['usuario'].hasError('minlength')">Usuario debe ser mínimo 3 caracteres.
        </mat-error>
        <mat-error *ngIf="registerForm.controls['usuario'].hasError('maxlength')">Usuario debe ser máximo 100 caracteres.
        </mat-error>
      </mat-form-field>
    </div>
  <div>
    <mat-form-field fxLayout="column" hintLabel="Ingrese su nombre" appearance="outline" class="input-width-275"
      floatLabel="always">
      <mat-label>Nombre(s):</mat-label>
      <input matInput formControlName="nombreUsuario" name="nombreUsuario" minlength="3" maxlength="20" autocomplete="off"
        required>
      <mat-icon matSuffix>person</mat-icon>
      <mat-error *ngIf="registerForm.controls['nombreUsuario'].hasError('required')">Nombre es requerido.</mat-error>
      <mat-error *ngIf="registerForm.controls['nombreUsuario'].hasError('minlength')">Nombre debe ser mínimo 3 caracteres.
      </mat-error>
      <mat-error *ngIf="registerForm.controls['nombreUsuario'].hasError('maxlength')">Nombre debe ser máximo 20 caracteres.
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field fxLayout="column" hintLabel="Ingrese su apellido" appearance="outline" class="input-width-275"
      floatLabel="always">
      <mat-label>Apellido(s):</mat-label>
      <input matInput formControlName="apellidoUsuario" name="apellidoUsuario" minlength="3" maxlength="20" autocomplete="off"
        required>
      <mat-icon matSuffix>person</mat-icon>
      <mat-error *ngIf="registerForm.controls['apellidoUsuario'].hasError('required')">Apellido es requerido.</mat-error>
      <mat-error *ngIf="registerForm.controls['apellidoUsuario'].hasError('minlength')">Apellido debe ser mínimo 3 caracteres.
      </mat-error>
      <mat-error *ngIf="registerForm.controls['apellidoUsuario'].hasError('maxlength')">Apellido debe ser máximo 20
        caracteres.
      </mat-error>
    </mat-form-field>
  </div>
</div>
<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column" class="divconten">
  <div>
    <mat-form-field fxLayout="column" hintLabel="Ingrese número de teléfono" appearance="outline" class="input-width-275"
      floatLabel="always">
      <mat-label>Número de Teléfono:</mat-label>
      <input matInput formControlName="numTelefonoUser" name="numTelefonoUser" mask="(000) 000-0000" minlength="10"
        maxlength="15" autocomplete="off">
      <mat-icon matSuffix>phone_enabled</mat-icon>
      <mat-error *ngIf="registerForm.controls['numTelefonoUser'].hasError('minlength')">Teléfono inválido. Formato: (000)
        000-0000</mat-error>
    </mat-form-field>
    </div>
    <div>
    <mat-form-field fxLayout="column" hintLabel="Formato: ejemplo@correo.com" appearance="outline" class="input-width-275"
      floatLabel="always">
      <mat-label>Correo Electrónico:</mat-label>
      <input matInput formControlName="correoUsuario" name="correoUsuario" maxlength="50" autocomplete="off" required>
      <mat-icon matSuffix>alternate_email</mat-icon>
      <mat-error *ngIf="registerForm.controls['correoUsuario'].hasError('required')">Correo electrónico es requerido.
      </mat-error>
      <mat-error *ngIf="registerForm.controls['correoUsuario'].hasError('pattern')">Correo inválido. Formato:
        ejemplo&#64;correo.com</mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field fxLayout="column" appearance="outline" class="input-width-275" floatLabel="always">
      <mat-label>Perfil</mat-label>
      <mat-select formControlName="perfilUsuario" required placeholder="Seleccione una opción">
        <mat-option value="1">Administrador</mat-option>
        <mat-option value="2">Cliente</mat-option>
      </mat-select>
      <mat-icon matSuffix>manage_accounts</mat-icon>
      <mat-error *ngIf="registerForm.controls['perfilUsuario'].hasError('required')">Perfil es requerido.</mat-error>
    </mat-form-field>
  </div>
</div>
<h1 style="margin-top: 30px;">Datos de la Empresa y Licencias</h1>
<hr>
<div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
  class="divconten">
  <div>
    <mat-form-field fxLayout="column" hintLabel="Ingrese nombre Empresa" appearance="outline" class="input-width-275"
      floatLabel="always">
      <mat-label>Razón Social:</mat-label>
      <input matInput formControlName="nombreEmpresa" name="nombreEmpresa" minlength="4" maxlength="50" autocomplete="off"
        required>
      <mat-icon matSuffix>apartment</mat-icon>
      <mat-error *ngIf="registerForm.controls['nombreEmpresa'].hasError('required')">Empresa es requerida.</mat-error>
      <mat-error *ngIf="registerForm.controls['nombreEmpresa'].hasError('minlength')">Empresa debe ser mínimo 4 caracteres.
      </mat-error>
      <mat-error *ngIf="registerForm.controls['nombreEmpresa'].hasError('maxlength')">Empresa debe ser máximo 30 caracteres.
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field fxLayout="column" hintLabel="Formato: X-000000000" appearance="outline" class="input-width-275"
      floatLabel="always">
      <mat-label>Número de RIF:</mat-label>
      <input matInput formControlName="numRif" name="numRif" maxlength="12" autocomplete="off" required>
      <mat-icon matSuffix>badge</mat-icon>
      <mat-error *ngIf="registerForm.controls['numRif'].hasError('required')">Número RIF es requerido.
      </mat-error>
      <mat-error *ngIf="registerForm.controls['numRif'].hasError('pattern')">RIF debe ser mayúscula, guión y 9
        digitos.</mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field fxLayout="column" hintLabel="Ingrese número de teléfono" appearance="outline" class="input-width-275"
      floatLabel="always">
      <mat-label>Número de Teléfono:</mat-label>
      <input matInput formControlName="numTelefonoEmpresa" name="numTelefonoEmpresa" mask="(000) 000-0000" minlength="10"
        maxlength="15" autocomplete="off" required>
      <mat-icon matSuffix>phone_enabled</mat-icon>
      <mat-error *ngIf="registerForm.controls['numTelefonoEmpresa'].hasError('required')">Número teléfono es requerido.
      </mat-error>
      <mat-error *ngIf="registerForm.controls['numTelefonoEmpresa'].hasError('minlength')">Teléfono inválido. Formato:
        (000) 000-0000</mat-error>
    </mat-form-field>
  </div>
</div>
<div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
  class="divconten">
  <div>
    <mat-form-field fxLayout="column" hintLabel="Formato: ejemplo@correo.com" appearance="outline" class="input-width-275"
      floatLabel="always">
      <mat-label>Correo Electrónico:</mat-label>
      <input matInput formControlName="correoEmpresa" name="correoEmpresa" maxlength="50" autocomplete="off">
      <mat-icon matSuffix>alternate_email</mat-icon>
      <mat-error *ngIf="registerForm.controls['correoEmpresa'].hasError('pattern')">Correo inválido. Formato:
        ejemplo&#64;correo.com</mat-error>
    </mat-form-field>
    </div>
    <div>
    <mat-form-field fxLayout="column" hintLabel="Ingrese la ciudad" appearance="outline" class="input-width-275"
      floatLabel="always">
      <mat-label>Ciudad:</mat-label>
      <input matInput formControlName="ciudadEmpresa" name="ciudadEmpresa" minlength="4" maxlength="30" autocomplete="off"
        required>
      <mat-icon matSuffix>location_on</mat-icon>
      <mat-error *ngIf="registerForm.controls['ciudadEmpresa'].hasError('required')">Ciudad es requerida.</mat-error>
      <mat-error *ngIf="registerForm.controls['ciudadEmpresa'].hasError('minlength')">Empresa debe ser mínimo 4 caracteres.
      </mat-error>
      <mat-error *ngIf="registerForm.controls['ciudadEmpresa'].hasError('maxlength')">Empresa debe ser máximo 30 caracteres.
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field fxLayout="column" hintLabel="Ingrese cantidad de Licencias" appearance="outline" class="input-width-275"
      floatLabel="always">
      <mat-label>Cantidad de Licencias:</mat-label>
      <input matInput formControlName="numLicencias" name="numLicencias" minlength="1" maxlength="5" autocomplete="off"
        required>
      <mat-icon matSuffix>pin</mat-icon>
      <mat-error *ngIf="registerForm.controls['numLicencias'].hasError('required')">Cantidad Licencias es requerido.
      </mat-error>
      <mat-error *ngIf="registerForm.controls['numLicencias'].hasError('pattern')">Cantidad Licencia inválida.</mat-error>
      </mat-form-field>
      </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
        class="divconten">
        <div>
          <mat-form-field fxLayout="column" hintLabel="Ingrese el número de serial" appearance="outline" class="input-width-275"
            floatLabel="always">
            <mat-label>Serial de Licencia:</mat-label>
            <input matInput formControlName="numSerial" name="numSerial" minlength="14" maxlength="20" autocomplete="off" required>
            <mat-icon matSuffix>vpn_key</mat-icon>
            <mat-error *ngIf="registerForm.controls['numSerial'].hasError('required')">Número Serial es requerido.
            </mat-error>
            <mat-error *ngIf="registerForm.controls['numSerial'].hasError('minlength')">Serial debe ser mínimo 14 caracteres.
            </mat-error>
            <mat-error *ngIf="registerForm.controls['numSerial'].hasError('maxlength')">Serial debe ser máximo 20 caracteres.
            </mat-error>
          </mat-form-field>
          </div>
          <div>
          <mat-form-field fxLayout="column" hintLabel="Seleccione fecha inicio" appearance="outline" class="input-width-275"
            floatLabel="always">
            <mat-label>Fecha Inicio Licencia:</mat-label>
            <input matInput (dateChange)="onDateChange($event)" formControlName="fechaInicioLicencia" [matDatepicker]="pickerStart"
              [min]="todayDate" readonly (click)="pickerStart.open()" required>
            <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerStart disabled="false"></mat-datepicker>
            <mat-error *ngIf="registerForm.controls['fechaInicioLicencia'].hasError('required')">Fecha inicio es requerida.
            </mat-error>
            <mat-error *ngIf="registerForm.controls['fechaInicioLicencia'].hasError('invalid')">Fecha inicio es inválida.
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field fxLayout="column" hintLabel="Seleccione fecha fin" appearance="outline" class="input-width-275"
            floatLabel="always">
            <mat-label>Fecha Fin Licencia:</mat-label>
            <input matInput formControlName="fechaFinLicencia" [matDatepicker]="pickerEnd" [min]="startDateFfin" readonly
              (click)="pickerEnd.open()" required>
            <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd [disabled]="disabledFfin"></mat-datepicker>
            <mat-error *ngIf="registerForm.controls['fechaFinLicencia'].hasError('required')">Fecha fin es requerida.
            </mat-error>
            <mat-error *ngIf="registerForm.controls['fechaFinLicencia'].hasError('invalid')">Fecha fin es inválida.
            </mat-error>
    </mat-form-field>
  </div>
</div>
<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="divconten">
<p style="font-weight: bold;">(*) Estos campos son obligatorios.</p>
</div>
<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
  class="divconten">
  <div fxLayout="column">
    <button mat-raised-button (click)="navigateMenu('home');" color="warn" type="button" class="align-center-middle">
      <span class="text-icon-space">Regresar a Home</span>
      <mat-icon>home</mat-icon>
    </button>
  </div>
  <div fxLayout="column">
    <button mat-raised-button color="primary" type="submit" class="align-center-middle">
      <span class="text-icon-space">Agregar Usuario</span>
      <mat-icon>data_saver_on</mat-icon>
    </button>
  </div>
</div>
<!-- <div>Form controls value: {{registerForm.value | json}} </div> -->
</form>
</div>
